import React from "react";

export const iframesTestPages = [
  {
    title: "Сводка",
    url: "/test/product-chart/:id",
    component: React.lazy(() => import("root/iframes/ProductChartById")),
  },
  {
    title: "Финансовый отчёт поставщика",
    url: "/test/seller_finance_report/:id",
    component: React.lazy(() => import("root/iframes/SellerFinanceReport")),
  },
  {
    title: "Категории",
    url: "/test/keywords-chart/:id",
    component: React.lazy(() => import("root/iframes/KeywordsChartById")),
  },
  {
    title: "Запросы",
    url: "/test/keywords-table/:id",
    component: React.lazy(() => import("root/iframes/KeywordsTableById")),
  },
  {
    title: "Динамика частотности запроса",
    url: "/test/request-analyzer/:keyword",
    component: React.lazy(() => import("root/iframes/RequestAnalizerByKeyword")),
  },
  {
    title: "Расширение запроса в динамике",
    url: "/test/wordstats/:keyword",
    component: React.lazy(() => import("root/iframes/WordstatByKeyword")),
  },
  {
    title: "Проверка кластера",
    url: "/test/clusterer/:keyword",
    component: React.lazy(() => import("root/iframes/ClustererByKeyword")),
  },
  {
    title: "Геопозиция",
    url: "/test/geo-size-location/:product",
    component: React.lazy(() => import("root/iframes/GeoSizeLocationById")),
  },
  {
    title: "Исходящий трафик",
    url: "/test/outside-traffic/:id",
    component: React.lazy(() => import("root/iframes/Outer")),
  },
  {
    title: "Сводная информация по запросу",
    url: "/test/keys-finder/:keyword",
    component: React.lazy(() => import("root/iframes/KeysFinderByKeyword")),
  },
  {
    title: "Позиции",
    url: "/test/position/:product_id/:phrase",
    component: React.lazy(() => import("root/iframes/PositionById")),
  },
];
